module.exports = __webpack_public_path__ + "static/2-Tri-01-0ea38cb6f5b73d1af112b8e6f60862ba.png";